import {forwardRef} from 'react'

import styles from './CompactCommentButton.module.css'

type CompactCommentButtonProps = {
  onClick: () => void
  id?: string
  children: React.ReactNode
}

export const CompactCommentButton = forwardRef<HTMLButtonElement, CompactCommentButtonProps>(
  ({onClick, id, children}, ref) => (
    <button type="button" id={id} ref={ref} onClick={onClick} className={styles.CompactCommentInputContainer}>
      {children}
    </button>
  ),
)

CompactCommentButton.displayName = 'CompactCommentButton'
